import { ChangeEvent, ReactElement, useEffect, useState } from 'react';
import { Input } from '@material-ui/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export interface ICrudFilterInputProps {
	onFilter: (value: string) => void;
	placeholder?: string;
	disabled?: boolean;
}

export function CrudFilterInput(props: ICrudFilterInputProps): ReactElement {
	const { onFilter, placeholder, disabled } = props;

	const delay: number = 300;

	const [value, setValue] = useState<string>('');
	const [subscription, setSubscription] = useState<Subscription>();
	const [subject] = useState<BehaviorSubject<string>>(
		new BehaviorSubject<string>(value)
	);

	useEffect(() => {
		setSubscription(
			subject.pipe(debounceTime(delay)).subscribe((val: string) => {
				onFilter(val);
			})
		);
		return cleanUp;
	}, []);

	useEffect(() => {
		subject.next(value);
	}, [value]);

	function cleanUp(): void {
		if (subscription) subscription.unsubscribe();
	}

	function onChange(e: ChangeEvent<HTMLInputElement>) {
		const val: string = e.target.value;
		setValue(val);
	}

	return (
		<Input
			disabled={disabled}
			placeholder={placeholder}
			value={value}
			fullWidth
			onChange={onChange}
		/>
	);
}
